<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group has-label">
              <label>Zeitraum</label>
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="Bis"
                start-placeholder="Anfangsdatum"
                end-placeholder="Enddatum"
                format="dd.MM.yyyy"
                value-format="yyyy-MM-dd"
                @change="filterData"
                :picker-options="{ firstDayOfWeek: 1 }"
              />
            </div>
            <product-select v-model="product"
              @input="filterData"
            />
            <div class="row">
              <div class="col-sm-6" v-if="warehouses.length > 1">
                <div class="form-group has-label">
                  <warehouse-select
                    v-model="warehouse"
                    :options="warehouses"
                    @input="filterData"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group has-label">
                  <label>Grund</label>
                  <multiselect v-model="cause"
                    :options="causes"
                    track-by="id"
                    label="name"
                    @input="filterData"
                  />
                </div>
              </div>
            </div>
            <div class="row" v-if="costCenters.length > 1">
              <div class="col-sm-6">
                <div class="form-group has-label">
                  <label>Kostenstelle</label>
                  <multiselect v-model="costCenter"
                    :options="costCenters"
                    track-by="id"
                    label="name"
                    @input="filterData"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group has-label">
                  <label>Ansicht</label>
                  <div>
                      <l-radio v-model="viewType" inline @input="filterData" label="variation">Kumuliert Variation</l-radio>
                      <l-radio v-model="viewType" inline @input="filterData" label="product">Kumuliert Produkt</l-radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Produkt</th>
              <th>Menge</th>
              <th>Einbuchungen</th>
              <th>Ausbuchungen</th>
              <th v-if="warehouses.length > 1">Lager</th>
            </tr>
          </thead>
          <transition name="el-fade-in-linear">
            <tbody v-if="! loading">
              <tr is="StockRotationRow"
                v-for="stockRotation in stockRotations"
                :key="stockRotation.id"
                :stock-rotation="stockRotation"
                :is-accumulated-view="true"
                :view-type="viewType"
                :show-warehouse="warehouses.length > 1"
              />
            </tbody>
          </transition>
        </table>
      </div>
    </div>
    <l-pagination
      background
      layout="prev, pager, next"
      :per-page="10"
      :page-count="pageCount"
      :value="currentPage"
      @input="changePage"
      @changePerPage="changePerPage"
    />
  </div>
</template>

<script>
import StockRotationRow from 'src/pages/StockRotations/stock-rotation-row'
import hasPagination from 'src/has-pagination'
import { DatePicker } from 'element-ui'
import { Radio as LRadio } from 'src/components'
import moment from 'moment'
import ProductSelect from 'src/components/product-select'
import WarehouseSelect from 'src/components/warehouse-select.vue'

export default {
  components: {
    LRadio,
    StockRotationRow,
    ProductSelect,
    [DatePicker.name]: DatePicker,
    WarehouseSelect
  },
  mixins: [hasPagination],
  data () {
    return {
      dateRange: [
        moment().subtract(1, 'years').startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD')
      ],
      stockRotations: [],
      loading: true,
      warehouses: [],
      causes: [],
      costCenters: [],
      warehouse: this.$store.state.filters.warehouse,
      product: null,
      cause: null,
      costCenter: null,
      viewType: 'variation'
    }
  },
  methods: {
    filterData () {
      this.loading = true
      this.changePage(1)
    },
    getCustomQueryData () {
      return {
        date_range: this.dateRange ? encodeURIComponent(this.dateRange) : '',
        product: this.product ? this.product.id : '',
        warehouse: this.warehouse ? this.warehouse.id : '',
        cause: this.cause ? this.cause.id : '',
        cost_center: this.costCenter ? this.costCenter.id : '',
        view_type: this.viewType
      }
    },
    getData (query) {
      return this.$http.get(`/stock_rotations?${query}`).then(({ data }) => {
        this.stockRotations = data.data
        this.pageCount = data.last_page
        this.loading = false
      })
    },
    // @override
    changePage (page) {
      if (this.currentPage !== page) {
        this.$router.push(`/stats/rotations?page=${page}`)
      } else {
        this.fetchTableData()
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.query && to.query.page) {
      this.currentPage = +to.query.page
      this.fetchTableData().then(() => { next() })
    } else {
      this.currentPage = 1
      this.fetchTableData().then(() => { next() })
    }
  },
  created () {
    if (this.$route.query && this.$route.query.page) {
      this.currentPage = +this.$route.query.page
    }

    this.fetchTableData()
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.warehouses = data
    })
    this.$http.get(`/causes`).then(({ data }) => {
      this.causes = data
    })
    this.$http.get(`/cost_centers`).then(({ data }) => {
      this.costCenters = data
    })
  }
}
</script>

<style>
</style>
